import React, { useCallback, useMemo } from 'react';
import { useCurrentDecedentId } from '@/app/providers/DecedentProvider';
import FormConstructor from '@/common/containers/FormConstructor/index';
import Loader from '@/common/components/Loader/index';
import { useQuestionListQuery } from '@/entities/question';

const ImmediateTasks = ({ onSubmit, ...props }) => {
  const decedentId = useCurrentDecedentId();
  const questionListQuery = useQuestionListQuery('immediate', decedentId);
  const payload = useMemo(() => {
    if (!questionListQuery.data) {
      return {};
    }

    const { list, answers } = questionListQuery.data;
    return {
      questions: list[0].questions,
      answers,
    };
  }, [questionListQuery.data]);
  const formKey = String(questionListQuery.dataUpdatedAt || '1');

  const handleSubmit = useCallback(
    async (form) => {
      await onSubmit(form);
      await questionListQuery.refetch();
    },
    [onSubmit, questionListQuery]
  );

  return payload.questions ? (
    <FormConstructor
      {...props}
      onSubmit={handleSubmit}
      questions={payload.questions}
      answers={payload.answers}
      key={formKey}
    />
  ) : (
    <Loader />
  );
};

export default ImmediateTasks;
